import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { UserLogin } from './../models/userLogin';

@Injectable({
    providedIn: 'root'
})

export class TokenAuthService {
    controller = 'TokenAuth';

    constructor(private base: BaseService) { }

    login(obj: UserLogin) {
        return this.base.save(this.controller + '/Authenticate', obj);
    }
}